import React, { useState, useEffect } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { observer } from 'mobx-react-lite';
import Video from 'components/Video';

import './index.sass';
import Page from '../../../pages/Page';
import Model from '../../../../model';

const { cnBlock, el } = bem('feelings-course-video');

const itemName = 'Материалы из курса Вероники «Про чувства»';
const title = itemName;
const FeelingsCourseVideo = () => {

    const { user } = Model;
    const [ loading, setLoading ] = useState(false);
    const [ item, setItem ] = useState(null);

    useEffect(() => {
        setLoading(true);
        user.getDigital(itemName)
            .then((digital) => {
                setLoading(false);
                if (digital !== undefined) {
                    setItem(digital);
                }
            })
            .catch((error) => {
                setLoading(false)
                console.log(error);
            });
    }, []);

    if (loading) {
        return <Page className={ cnBlock() } title={ title } loading={ loading }/>
    }

    if (!item) {
        return <Page className={ cnBlock() } title={ title }>
            <div className={ el('content') }>
                <div className={ el('info') }>
                    <Text>{ `Курс не был приобретен для пользователя ${ user.username }` }</Text>
                </div>
            </div>
        </Page>
    }

    const files = item?.digital?.files.filter(file => !!file.isActive);

    if (files.length === 0) {
        return <Page className={ cnBlock() } title={ title }>
            <div className={ el('content') }>
                <div className={ el('info') }>
                    <Text>{ `Курс не содержит материалов` }</Text>
                </div>
            </div>
        </Page>;
    }

    return (
        <Page className={ cnBlock('supervision-course-page') } title={ itemName }>
            <div className={ el('video-list') }>
                <div className={ el('video-block', 'first') }>
                    <div className={ el('description') }>
                        <Text serif>Почему из раза в раз не получается построить отношения? Что не дает нам оставаться и
                            продолжать, почему мы терпим неудачу?</Text>
                    </div>
                    <div className={ el('video') }>
                        <Video muted={ false } src='/media/digital/Codependent_1st_part.mp4' width='100%' height='100%'
                               autoplay={ false } controls='true'/>
                    </div>
                </div>
                <div className={ el('video-block', 'first') }>
                    <div className={ el('description') }>
                        <Text serif>О чувствах. Это разговор о любви к себе, обиде, зависти, о том, что такое обесценивание и
                            помощь близким на самом деле.</Text>
                    </div>
                    <div className={ el('video') }>
                        <Video muted={ false } src='/media/digital/About_feelings_3rd_part-003.mp4' width='100%'
                               height='100%'
                               autoplay={ false } controls='true'/>
                    </div>
                </div>
            </div>
            <div className={ el('references') }>
                <div className={ el('annotations') }>
                    <Text tag='div'>Материалы составлены с опорой на экспертизу моих экспертных
                        консультантов:</Text>
                    <Text tag='div'>Анастасию Долганову и Людмилу Петрановскую</Text>
                </div>
                <div className={ el('links') }>
                    <div className={ el('links-title')}>
                        <Text tag='div' serif>Литература:</Text>
                    </div>
                    <div className={el('links-list')}>
                        <Text tag='div'>Нэнси Мак-Вильямс «Формулирование психоаналитического случая»</Text>
                        <Text tag='div'>Пол Холмс «Внутренний мир снаружи: Теория объектных отношений и
                            психодрама»</Text>
                        <Text tag='div'>Дональд Калшед «Внутренний мир травмы. Архетипические защиты личностного
                            духа»</Text>
                    </div>
                </div>
            </div>
        </Page>
    )
};

export default observer(FeelingsCourseVideo);
